import { useFetcher, useLocation } from "@remix-run/react";
import { useCallback } from "react";

export function useSetLocale() {
  const fetcher = useFetcher({ key: "set-locale" });
  const location = useLocation();

  return useCallback(
    (locale: string | "en" | "fr") => {
      const queryString = window.location.search;
      const formData = new FormData();
      formData.append("lang", locale);
      formData.append("redirectTo", `${location.pathname}${queryString}`);
      fetcher.submit(formData, {
        action: "/i18n",
        method: "post",
      });
    },
    [location.pathname, fetcher.state],
  );
}
